import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { PageHeader } from "@/pages/admin/AdminDashboard";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download } from "lucide-react";

export default function SalarieDocuments() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try { const { data } = await api.get("/salarie/documents"); setItems(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const download = async (id, name) => {
    try {
      const res = await api.get(`/files/document/${id}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = name; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error("Téléchargement impossible"); }
  };

  return (
    <div className="min-h-full">
      <PageHeader eyebrow="RH" title="Documents RH" sub="Contrats, attestations et documents partagés par votre entreprise." />
      <div className="p-6 lg:p-10">
        <div className="bg-white border border-[#DEE2E6]" data-testid="salarie-docs-list">
          <div className="grid grid-cols-12 gap-4 p-4 text-xs uppercase tracking-[0.2em] font-semibold bg-[#F8F9FA] border-b border-[#DEE2E6]">
            <div className="col-span-4">Titre</div>
            <div className="col-span-5">Fichier</div>
            <div className="col-span-2">Date</div>
            <div className="col-span-1 text-right"></div>
          </div>
          {items.length === 0 ? (
            <div className="p-8 text-center text-sm text-[#868E96]">Aucun document.</div>
          ) : items.map((d) => (
            <div key={d.id} className="grid grid-cols-12 gap-4 p-4 border-b border-[#DEE2E6] items-center text-sm" data-testid={`doc-${d.id}`}>
              <div className="col-span-4 font-display font-bold">{d.titre}</div>
              <div className="col-span-5 truncate text-[#495057]">{d.original_filename}</div>
              <div className="col-span-2 font-mono text-xs">{new Date(d.uploaded_at).toLocaleDateString("fr-FR")}</div>
              <div className="col-span-1 text-right">
                <Button size="sm" variant="outline" onClick={() => download(d.id, d.original_filename)} data-testid={`download-doc-${d.id}`}><Download className="h-3 w-3" /></Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
